import { HintText } from '#components/atoms/forms/index.ts';

// Every network is assigned a /80 out of our /48, which is 2^48 addresses.
const ASSIGNED_IPV6_ADDRESS_COUNT = 281_474_976_710_656;

type Props = {
  className?: string;
};

export function AssignedIPv6NetworkSize({ className }: Props) {
  return <HintText className={className}>{ASSIGNED_IPV6_ADDRESS_COUNT.toLocaleString()} addresses</HintText>;
}
